import React, { useEffect, useState } from "react";
import { Modal, ModalDialog, Button, Input } from "@mui/joy";
import { Switch } from "@mui/material";
import { postFetch } from "../../../../../../fetch/fetch";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import styles from "./phoneinbound.module.css";

const toastOptions : any = {
    position: "bottom-right",
    autoClose: 3000,
    hideProgressBar: true,
    theme: "colored"
};

//010-0000-0000 자동 하이픈
const formatPhone = (raw : string) => {
    const digits = String(raw || "").replace(/\D/g, "").slice(0, 11);
    if (digits.length < 4) return digits;
    if (digits.length < 8) return digits.slice(0, 3) + "-" + digits.slice(3);
    return digits.slice(0, 3) + "-" + digits.slice(3, 7) + "-" + digits.slice(7);
};

//내선 상세 — 휴대폰 번호 저장 + 외근(Follow Me 휴대폰 착신) 토글
//표시 상태는 항상 서버가 astdb를 재읽은 값 (쓴 값 echo 아님). 번호 없이는 외근을 켤 수 없다
const ExtensionFollowMeModal : React.FC<any> = (props) => {

    const [phoneInput, setPhoneInput] = useState<string>("");
    const [savingMobile, setSavingMobile] = useState<boolean>(false);
    const [togglingAway, setTogglingAway] = useState<boolean>(false);

    useEffect(() => {
        if (props.open && props.row) {
            setPhoneInput(formatPhone(props.row.mobile || ""));
            setSavingMobile(false);
            setTogglingAway(false);
        }
    }, [props.open]);

    const r = props.row;
    if (!r) {
        return null;
    }

    const digits = phoneInput.replace(/\D/g, "");
    const busy = savingMobile || togglingAway;

    const saveMobile = async () => {
        if (digits !== "" && !/^010\d{8}$/.test(digits)) {
            toast.error("휴대폰 번호는 010으로 시작하는 11자리 숫자여야 합니다", toastOptions);
            return;
        }
        setSavingMobile(true);
        try {
            const result : any = await postFetch("/dashboard/callcenter/followme/mobile", { extension: r.extension, mobile: digits });
            if (result.message === "success") {
                toast.success(digits ? "휴대폰 번호를 저장했습니다" : "휴대폰 번호를 삭제했습니다", toastOptions);
                props.onChanged(result.extension);
                setPhoneInput(formatPhone((result.extension && result.extension.mobile) || ""));
            } else {
                toast.error(result.message || "저장 실패", toastOptions);
            }
        } catch (e) {
            console.log(e);
            toast.error("저장 실패", toastOptions);
        }
        setSavingMobile(false);
    };

    const toggleAway = async (on : boolean) => {
        setTogglingAway(true);
        try {
            const result : any = await postFetch("/dashboard/callcenter/followme/away", { extension: r.extension, on });
            if (result.message === "success") {
                toast.success(result.extension && result.extension.awayOn ? "외근을 켰습니다 — 휴대폰으로도 벨이 울립니다" : "외근을 껐습니다", toastOptions);
                props.onChanged(result.extension);
            } else {
                toast.error(result.message || "교환기 반영 실패", toastOptions);
            }
        } catch (e) {
            console.log(e);
            toast.error("교환기 반영 실패", toastOptions);
        }
        setTogglingAway(false);
    };

    return (
        <Modal open={props.open} onClose={props.onClose}>
            <ModalDialog>
                <div style={{ width: "360px" }}>
                    <div className={styles.modalTitle}>{r.name} <span className={styles.ext}>{r.extension}</span></div>

                    <div className={styles.modalLabel}>휴대폰 번호</div>
                    <div className={styles.fmInputRow}>
                        <Input
                            value={phoneInput}
                            placeholder="010-0000-0000"
                            onChange={(e) => setPhoneInput(formatPhone(e.target.value))}
                            onKeyDown={(e) => { if (e.key === "Enter") saveMobile(); }}
                            sx={{ flex: 1 }}
                        />
                        <Button variant="solid" onClick={saveMobile} loading={savingMobile} disabled={togglingAway}>저장</Button>
                    </div>

                    <div className={styles.fmAwayRow}>
                        <div>
                            <div className={styles.fmAwayTitle}>외근 (휴대폰 착신)</div>
                            <div className={styles.fmAwayDesc}>유선과 휴대폰이 같이 울립니다. 휴대폰으로 받으면 안내 후 1번을 눌러야 연결됩니다.</div>
                            {
                                !r.mobile ?
                                    <div className={styles.fmAwayDesc}>휴대폰 번호를 먼저 등록하면 외근을 켤 수 있습니다.</div>
                                    :
                                    ""
                            }
                        </div>
                        <Switch
                            size="small"
                            checked={!!r.awayOn}
                            disabled={!r.mobile || busy}
                            onChange={(e) => toggleAway(e.target.checked)}
                        />
                    </div>

                    <div className={styles.modalHint}>전화기에서 *21로 켜고 끈 것도 여기에 그대로 반영됩니다</div>

                    <div className={styles.modalButtons}>
                        <Button variant="plain" color="neutral" onClick={props.onClose}>닫기</Button>
                    </div>
                </div>
            </ModalDialog>
        </Modal>
    );
};

export default ExtensionFollowMeModal;
